import { render, staticRenderFns } from "./ConsultCalendarEventCard.vue?vue&type=template&id=118600ec"
import script from "./ConsultCalendarEventCard.vue?vue&type=script&lang=ts"
export * from "./ConsultCalendarEventCard.vue?vue&type=script&lang=ts"
import style0 from "./ConsultCalendarEventCard.vue?vue&type=style&index=0&id=118600ec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports